<template>
  <BaseWidget
    class="accountant-profile"
    :loading="loading"
    @refresh-data="refreshData" 
    @set-config="setConfig"
    v-on="$listeners"
  >
    <template v-slot:content>
      <div class="accountant-profile-wrap">
        <div class="progress-wrap" @click="$router.push({ name: 'AccountantCompanySettings' })">
            <b-avatar
              class=""
              :src="currentCompany.logo ? currentCompany.logo : ''"
              :text="currentCompany.name[0]"
              size="125px"
            />
            <h3>{{ currentCompany.name }}</h3>
            <div class="progress-wrap--hint">
              {{ currentCompany.address }} {{ currentCompany.city }}
            </div>
          </div>
      </div>
    </template>
  </BaseWidget>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BaseWidget from "@/components/dashboard/widgets/BaseWidget"

export default {
  name: 'accountant-profile-widget',
  components: { 
    BaseWidget, 
  },
  props: {
    widget: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      companyMissingFields: 'main/getCompanyMissingFields',
      currentUser: 'main/getCurrentUser',
      targetData: 'main/getCompanyRequiredData',
      isWaitingForResponse: "main/isWaitingForResponse"
    })
  },
  created () {

  },
  mounted () {
    this.setupWidget()
    this.setObjectStatus(this.widget.config)
  },
  methods: {
    ...mapActions({ 
      loadCurrentCompany: "main/loadCurrentCompany"
    }),
    setConfig (config) {
      if (config.status) this.setObjectStatus(config)
      this.$emit('save-config', this.config)
    },
    setObjectStatus (config) {
      if (config.status) {
        this.config.status = (config.status && config.status !== 'all') ? config.status : ''
      } 
      this.setFilters()
    },
    setFilters (status = false) {
      this.filters.status = (status) ? (status === 'all') ? '' : status : this.config.status
      this.refreshData()
    },
    refreshData () {
      this.getData()
    },
    updateFilters (status) {
      this.filters.status = (status === 'all') ? '' : status
      this.setFilters(status)
    },
    getData () {
      this.loading = true
      this.loadCurrentCompany().then(() => {
        this.loading = false
      })
    },
    setupWidget () {
      this.title = this.$gettext('Accountant profile')
    },
    removeWidget () {
      this.$emit('widget-event', { 'event': 'remove' })
      setTimeout(() => {
        this.$emit('widget-event', { 'event': 'update', 'target': 'activities-timeline-widget' })
      }, 100);
    }
  }
}
</script>

<style lang="scss">
.loading-spinner-button {
  .loading-spinner {
    width: auto !important;
  } 
}

.widget-wrapper.accountant-profile {
  cursor: pointer;
  background: var(--branding-color);
  &:not(.incomplete) {
    // border: 5px solid $colorBrand !important;
  }
  &.incomplete {
    border: 5px solid #ffcd1f !important;
  }
}

.accountant-profile {
  .widget-dropdown-toggle {
    color: var(--text-hl-branding-color) !important;
  }
  .accountant-profile-wrap {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
  }
  .progress-wrap {
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    line-height: 1.2;
    h3 {
      color: var(--text-hl-branding-color);
    }
    &--hint {
      font-size: 14px;
      color: #0000007d;
      margin-top: 5px;
    }
  }
  .incomplete-wrap {
    width: 100%;
    position: relative;
    font-size: 14px;
    .missing-list {
      list-style: none;
      margin: 0; margin-top: 10px;
      padding: 0;
      padding-left: 15px;
      li {
        padding-left: 20px;
        position: relative;
        &:before {
          content: '';
          width: 8px;
          height: 8px;
          border-radius: $radiusXl;
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translateY(-50%);
          background: $colorBrand;
        }
      }
    }
  }

  .incomplete-content-wrap {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1;
    .progress-count {
      font-size: 20px;
      font-family: DINNextLTPro-Medium, sans-serif;
      color: $colorAppInvoices;
      margin-bottom: 0.5rem;
      position: relative;
      .progress-number {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
      .donut-wrap {
        width: 75px;
        height: 75px;
      }
      // canvas {
      //   width: 75px;
      //   height: 75px;
      // }
    } 
    .incomplete-content { 
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: center;
      justify-content: flex-end;
      align-items: center;
      h4 { margin: 0; margin-bottom: 0.5rem; }
      p { display: none; font-size: 14px; color: $colorUnassigned; }
      .btn {  white-space: nowrap;}
    }

    @media (min-width: '992px') {
      flex-direction: row;
      .progress-count {
        font-size: 26px;
        font-family: DINNextLTPro-Medium, sans-serif;
      }
      .incomplete-content { 
        p { display: block; }
        padding-left: 0.25rem;
      }
    }

  }


  .anim-warning {
    width: 100px !important;
    height: 100px !important;
    margin: -1rem !important;
  }
  .anim-success {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .remove-widget-link {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
